export function parseShapePoints(shape?: string | null | undefined): [number, number][] {
  if (!shape) return []

  try {
    const parsed = JSON.parse(shape)

    if (
      Array.isArray(parsed) &&
      parsed.every(p => Array.isArray(p) && p.length === 2 && typeof p[0] === 'number' && typeof p[1] === 'number')
    ) {
      return parsed
    }

    return []
  } catch (err) {
    console.error('Invalid shape JSON:', shape, err)
    return []
  }
}

export function parsePoint(point?: string | null | undefined): [number, number] | null {
  if (!point) return null

  try {
    const parsed = JSON.parse(point)

    if (
      Array.isArray(parsed) &&
      parsed.length === 2 &&
      typeof parsed[0] === 'number' &&
      typeof parsed[1] === 'number'
    ) {
      return [parsed[0], parsed[1]]
    }

    return null
  } catch (err) {
    console.error('Invalid point JSON:', point, err)
    return null
  }
}
